import { render, staticRenderFns } from "./mypdList.vue?vue&type=template&id=f537f03a&scoped=true&"
import script from "./mypdList.vue?vue&type=script&lang=js&"
export * from "./mypdList.vue?vue&type=script&lang=js&"
import style0 from "./mypdList.vue?vue&type=style&index=0&id=f537f03a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f537f03a",
  null
  
)

export default component.exports